import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { UserAuth } from "../context/AuthContext";
import { FiEye, FiEyeOff } from "react-icons/fi";
import "../styles/Sign.css";
import toast, { Toaster } from "react-hot-toast";
import SignStyle from "../components/SignStyle";
import SignDesc from "../components/SignDesc";
import SignInput from "../components/SignInput";
import SignButton from "../components/SignButton";

const Signin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const { signIn } = UserAuth();
  const [errorEmail, setErrorEmail] = useState(false);
  const [errorPassword, setErrorPassword] = useState(false);
  const { user } = UserAuth();

  useEffect(() => {
    if (user) {
      navigate("/beranda");
    }
  }, [user, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await signIn(email, password);
      toast.success("Berhasil masuk ke akun");
      navigate("/beranda", { replace: true });
    } catch (e) {
      toast.error("Email dan password salah");
    }
  };

  const handleToggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const validateEmail = (email) => {
    const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return re.test(String(email).toLowerCase());
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    setErrorEmail(!validateEmail(e.target.value));
  };

  const isPasswordValid = (password) => {
    return password.length > 0;
  };

  const handlePasswordChange = (e) => {
    const newPassword = e.target.value;
    setPassword(newPassword);

    if (!isPasswordValid(newPassword)) {
      setErrorPassword(true);
    } else {
      setErrorPassword(false);
    }
  };

  return (
    <div className="root-sign">
      <div className="sign-wrapper">
        <div className="sign-form__wrapper">
          <h1 className="sign-form__judul">Masuk</h1>
          <form
            onSubmit={handleSubmit}
            className="sign-form"
            name="signin-form"
          >
            <div className="sign-form__detail">
              <SignDesc statusAcc="Belum" textLink="Daftar" to="/daftar" />
              <SignInput
                sign="email"
                signLabel="Email"
                onChange={handleEmailChange}
                autoComplete="email"
                typeInput="email"
                errCondition={errorEmail}
              />

              <SignInput
                sign="password"
                signLabel="Password"
                onChange={handlePasswordChange}
                autoComplete="current-password"
                typeInput={showPassword ? "text" : "password"}
                passwordIcon={
                  showPassword ? (
                    <FiEye
                      onClick={handleToggleShowPassword}
                      className="icon-eye__open icon-eye"
                    />
                  ) : (
                    <FiEyeOff
                      onClick={handleToggleShowPassword}
                      className="icon-eye__close icon-eye"
                    />
                  )
                }
                errCondition={errorPassword}
              />
            </div>
            <SignButton text="Masuk" />
          </form>
        </div>
        <SignStyle />
      </div>
      <Toaster />
    </div>
  );
};

export default Signin;
